import { render, staticRenderFns } from "./c-common-search.vue?vue&type=template&id=49e4f064&scoped=true"
import script from "./c-common-search.vue?vue&type=script&setup=true&lang=js"
export * from "./c-common-search.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-common-search.vue?vue&type=style&index=0&id=49e4f064&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e4f064",
  null
  
)

export default component.exports